export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6110.918181ab.jpg";